import axios from 'axios'
import { ARES_URL } from './settings'

export type AresIcoValidationState = 'valid' | 'invalid'

class AresApi {
  api = axios.create({
    baseURL: ARES_URL,
  })

  private validationState = new Map<string, AresIcoValidationState>()

  getSubjectValidationState = (ico: string): AresIcoValidationState | undefined => {
    return this.validationState.get(ico.trim())
  }

  hasSubject = async (ico: string): Promise<boolean> => {
    const normalizedIco = ico.trim()
    const currentState = this.validationState.get(normalizedIco)

    if (currentState === 'valid') return true
    if (currentState === 'invalid') return false
    try {
      await this.api.get(`/${normalizedIco}`)
      this.validationState.set(normalizedIco, 'valid')
      return true
    } catch (e) {
      this.validationState.set(normalizedIco, 'invalid')
      return false
    }
  }
}

export default new AresApi()
